import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortByOfferLookupComponent } from './sort-by-offer-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [SortByOfferLookupComponent],
  exports: [SortByOfferLookupComponent],
  providers: []
})
export class SortByOfferLookupModule { }
